<script>
  import { tick, onMount } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');
  import ComponentEvents from '@utils/component-events';
  import queryString from 'query-string';
  import BrowserUtils from '@utils/browser-utils';

  import Like from '@app-components/rec_object/parts/Like.svelte';
  import Review from '@app-components/rec_object/parts/Review.svelte';
  import Comments from '@app-components/comments/Comments.svelte';
  import AddComment from '@app-components/comments/AddComment.svelte';

  import BookmarkButton from '@app-components/BookmarkButton.svelte';

  import DetailViewBox from './DetailViewBox.svelte';

  export let recObject;
  export let close;
  export let goToWeblink;
  export let goToEmail;
  export let goToInstagram;
  export let goToPhone;
  export let copyLink;
  export let showActionBar;
  export let showShareCard;
  export let showBookmark;
  export let getWeblinkOrAffilateUrl;
  export let customGroupStore;

  import jQuery from 'jquery';

  let group = customGroupStore || groupStore;
  let recs = recsStore.where({ rec_object_id: recObject.id });
  let rec = recs && recs[0];

  let mobile = false;
  let scrollableRightEl;

  let toggleBookmark;

  let setupClickTriggers = function (node) {
    jQuery(node).on('click', () => {
      ComponentEvents.trigger('close-all-options-menu');
    });

    return {
      destroy() {
        jQuery(node).off('click');
      },
    };
  };

  let isCommentEditMode = false;
  let addCommentKey = 0;

  let handleOverlayClick = function () {
    addCommentKey += 1;
  };

  onMount(() => {
    let queryParams = queryString.parse(location.search) || {};

    let commentId = queryParams['comment_id'] || queryParams['commentId'];

    if (commentId != null) {
      setTimeout(async () => {
        let elem = document.getElementById(`comment-box-${commentId}`);
        let container = document.querySelector('.detail-scrollable-notes-comments');
        await BrowserUtils.goToElementWithinContainer(elem, container, {
          behavior: 'smooth',
          block: 'end',
          inline: 'center',
        });
        commentId = null;
      }, 200);
    }
  });
</script>

<style style="text/scss" lang="scss">
  .detail-container {
    display: flex;
    padding: 30px;
    margin-top: -50px;
    margin-left: -30px;
    .detail-container-left {
      margin-right: 30px;
      display: flex;
      z-index: 10;
    }
    .detail-container-right {
      width: 100%;
      border-left: 1px solid #ececec;
      margin-top: -40px;
      padding-top: 40px;
      margin-bottom: -40px;
      padding-bottom: 100px;
      position: relative;
      // margin-left: 30px;

      .detail-container-right-inner {
        padding-left: 30px;
        height: 577px;
      }

      .detail-action-bar {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        .detail-action-button {
          border: 2px solid #ececec;
          border-radius: 8px;
          cursor: pointer;
          height: 39px;
          display: flex;
          align-items: center;
        }

        .detail-share-button {
          padding: 8px;
          padding-left: 12px;
          padding-right: 12px;

          &:hover {
            border: 2px solid #ececec;
            background: #ececec;
          }
        }
      }

      .detail-scrollable-notes-comments {
        height: 500px;
        margin-right: -59px;
        padding-right: 10px;
        overflow: auto;
        // padding-bottom: 100px;
        margin-top: 40px;

        .detail-comments {
          border-top: 1px solid #ececec;

          padding-top: 40px;
          margin-top: 20px;
          padding-bottom: 20px;
          display: flex;
          flex-direction: column;
          max-width: 450px;

          .detail-comment-label {
            font-size: 14px;
            line-height: 20px;
            color: #1a1a1a;
            opacity: 0.5;
          }
        }
      }
    }
  }

  .add-comment-container {
    position: absolute;
    width: calc(100% + 60px);
    border-top: 1px solid #ececec;
    bottom: 0;
    padding: {
      top: 15px;
      left: 30px;
      bottom: 40px;
    }
    z-index: 11;
    background: white;

    // // // Create a nested element for the shadow
    &__shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: 0px -4px 28px 0px rgba(0, 0, 0, 0.08);
      clip-path: inset(-28px 0px 0px 0px);
      z-index: -1;
    }

    .inner {
      padding-right: 34px;
      position: relative;
      z-index: 1;
    }
  }
</style>

<div class="detail-container" use:setupClickTriggers>
  <div class="detail-container-left">
    <DetailViewBox
      customGroupStore={customGroupStore}
      showActionBar={showActionBar}
      showShareCard={showShareCard}
      recObject={recObject}
      close={close}
      mobile={mobile}
      getWeblinkOrAffilateUrl={getWeblinkOrAffilateUrl}
      goToWeblink={goToWeblink}
      goToEmail={goToEmail}
      goToPhone={goToPhone}
      goToInstagram={goToInstagram} />
  </div>

  <div class="detail-container-right">
    <div class="detail-container-right-inner">
      <div class="detail-action-bar">
        {#if group.show_likes}
          <Like
            customGroupStore={customGroupStore}
            viewStyle="detail-view"
            recObjectId={recObject.id}
            style="margin-top: 0px; box-shadow: unset; height: 39px;" />
        {/if}

        <div style="flex: 1" />

        <span class="detail-action-button detail-share-button" on:click|preventDefault={copyLink}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 9.85059V12.8396C1 15.1371 2.8625 16.9996 5.16
            16.9996H12.8399C15.1374 16.9996 16.9999 15.1371 16.9999
            12.8396V9.85059"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M8.99982 9.85117V1"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M13.7997 6.31068L8.99969 1L4.19971 6.31068"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>

        {#if showBookmark}
          <span
            class="detail-action-button detail-share-button detail-bookmark-button"
            style="margin-left: 12px;"
            on:click|preventDefault|stopPropagation={toggleBookmark}>
            <BookmarkButton rec={rec} bind:toggleBookmark={toggleBookmark} mobile={false} />
          </span>
        {/if}
      </div>

      <div
        class="detail-scrollable-notes-comments purple-scrollbar"
        bind:this={scrollableRightEl}
        style={recObject.comments && recObject.comments.total && recObject.comments.total > 0 ? 'overflow:auto' : ''}>
        {#if rec}
          <div class="detail-notes">
            <Review
              customGroupStore={customGroupStore}
              style="padding: 0px"
              nameDescriptionStyle="margin-left: 10px; margin-right: -25px;"
              mobile={mobile}
              id={rec.id}
              view="detail-view"
              lines={99999} />
          </div>
        {/if}

        <div class="detail-comments">
          <span class="detail-comment-label">All Comments</span>

          {#if group.show_comments}
            {#if recObject.comments?.data?.length > 0}
              <Comments
                customGroupStore={customGroupStore}
                recObjectId={recObject.id}
                mobile={mobile}
                viewStyle="detail-view"
                on:changed={async () => {
                  await tick();
                }} />
            {/if}

            {#if !recObject.comments || !recObject.comments.total}
              <div style="margin-top: 15px">
                <AddComment
                  context={'rec'}
                  mobile={false}
                  customGroupStore={customGroupStore}
                  recObjectId={recObject.id}
                  inlineStyling={true}
                  commentContainerHeight={0} />
              </div>
            {/if}
            <div style="height: 20px">&nbsp;</div>
          {/if}
        </div>
      </div>
    </div>
    {#if group.show_comments && recObject.comments && recObject.comments.total && recObject.comments.total > 0}
      {#if isCommentEditMode}
        <div class="add-comment-edit-mode-overlay" on:click={handleOverlayClick}></div>
      {/if}
      <div class="add-comment-container">
        <div class="add-comment-container__shadow"></div>
        <div class="inner">
          {#key addCommentKey}
            <AddComment
              bind:editMode={isCommentEditMode}
              context={'rec'}
              mobile={false}
              customGroupStore={customGroupStore}
              recObjectId={recObject.id} />
          {/key}
        </div>
      </div>
    {/if}
  </div>
</div>
